import React from 'react';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'LiveblogStickyElectionLoader' */ './LiveblogStickyElection'),
  loading: () => null,
});

export default class LiveblogStickyElectionLoader extends React.Component {
  constructor(props) {
    super(props);
    this.state = { mounted: false };
  }
  componentDidMount() {
    this.setState({ mounted: true });
  }
  render() {
    return this.state.mounted ? <LoadableComponent {...this.props} /> : null;
  }
}
